import { gsePricingApi } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

export const EXECUTIONS_ACTION_TYPE = createNamedActions('marginCenter/executions', {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  GET_EXECUTIONS: 'GET_EXECUTIONS',
});

// LEN-79: read-only. The per-seller Freddie execution-leg enablement (commitment × servicing) shown on the
// Feeds & Sources Cash executions card — resolved from the freddie-feed card the pull engine reads. Editing
// moved to the Integration Studio card (the single write home), so there is no save action here. An empty
// catalog is a legitimate response (feed not connected), never an error state — a 403/degraded read reduces
// to hasError so the card surfaces it inline.
export const getExecutionsAction =
  ({ seller } = {}) =>
  async dispatch => {
    dispatch({ type: EXECUTIONS_ACTION_TYPE.SET_LOADING, payload: true });

    try {
      const { data } = await gsePricingApi.getExecutions({ seller });

      return dispatch({ type: EXECUTIONS_ACTION_TYPE.GET_EXECUTIONS, payload: data ?? null });
    } catch {
      return dispatch({ type: EXECUTIONS_ACTION_TYPE.SET_ERROR });
    }
  };
